import { AddWaterIntakeCard } from "./components/AddWaterIntakeCard/AddWaterIntakeCard";
import { TrackerType } from "core/state/Trackers/TrackerType";
import { WaterTrackerChart } from "./components/WaterTrackerChart";
import { WaterTrackerProgressCard } from "./components/Progress/WaterTrackerProgressCard";
import { t } from "i18next";
import PageTitle from "UIPalette/PageTitle/PageTitle";
import { Tracker } from "../components/Trackers/Tracker";

export const WaterTracker = () => {
  return (
    <>
      <PageTitle title={t("pageTitle.wellbeing.waterTracker")} />
      <Tracker trackerType={TrackerType.Water} heading={t("wellbeing.trackers.water.heading")}>
        <WaterTrackerProgressCard />
        <WaterTrackerChart />
        <AddWaterIntakeCard />
      </Tracker>
    </>
  );
};
